import {
  CreateGHADiscountRuleBody,
  GHADiscountRule,
  GHADiscountRuleAccountType,
  GHADiscountRuleApplication,
  GHADiscountRuleType,
  UpdateGHADiscountRuleBody,
} from '~/services/ConnectionGoogleService';
import { formatDateWithClock, parseDayjs } from '~/services/TimeService';

import { GHA_DISCOUNT_ACCOUNT_TYPE_OPTIONS } from './constants';

export type GHADiscountRuleFormState = {
  propertyId: string;
  accountType: GHADiscountRuleAccountType;
  discountType: GHADiscountRuleType;
  discountApplication: GHADiscountRuleApplication;
  discountValue: string;
  minAdvanceBookingWindow: string;
  minLengthOfStay: string;
  enabled: boolean;
  startsAt: string;
  endsAt: string;
};

export function toApiDateTime(value: string) {
  return value ? parseDayjs(value).toISOString() : null;
}

export function toCreateGHADiscountRuleBody(form: GHADiscountRuleFormState): CreateGHADiscountRuleBody {
  return {
    propertyId: form.propertyId.trim(),
    accountType: form.accountType,
    discountType: form.discountType,
    discountApplication: form.discountApplication,
    discountValue: Number(form.discountValue),
    minAdvanceBookingWindow: Number(form.minAdvanceBookingWindow),
    minLengthOfStay: Number(form.minLengthOfStay),
    enabled: form.enabled,
    startsAt: toApiDateTime(form.startsAt),
    endsAt: toApiDateTime(form.endsAt),
  };
}

export function toUpdateGHADiscountRuleBody(form: GHADiscountRuleFormState): UpdateGHADiscountRuleBody {
  return {
    discountType: form.discountType,
    discountApplication: form.discountApplication,
    discountValue: Number(form.discountValue),
    minAdvanceBookingWindow: Number(form.minAdvanceBookingWindow),
    minLengthOfStay: Number(form.minLengthOfStay),
    enabled: form.enabled,
    startsAt: toApiDateTime(form.startsAt),
    endsAt: toApiDateTime(form.endsAt),
  };
}

export function formatDiscountAccountType(value: string) {
  return GHA_DISCOUNT_ACCOUNT_TYPE_OPTIONS.find((option) => option.value === value)?.label ?? value;
}

export function formatRuleDiscount(rule: GHADiscountRule) {
  const value = rule.discountType === 'percentage' ? `${rule.discountValue}%` : `$${rule.discountValue}`;
  const application = rule.discountApplication === 'per_night' ? 'per night' : 'per stay';
  return `${value} ${application}`;
}

export function formatDateRange(rule: GHADiscountRule) {
  const startsAt = rule.startsAt ? formatDateWithClock(rule.startsAt) : 'Always';
  const endsAt = rule.endsAt ? formatDateWithClock(rule.endsAt) : 'No end';
  return `${startsAt} - ${endsAt}`;
}

export function formatDateTime(value?: string | null) {
  return value ? formatDateWithClock(value) : '-';
}
